import css from 'styled-jsx/css';

const staticStyles = css.global`
  @import 'src/common/styling/_mixins-scss/screen-size';
  @import 'src/common/styling/_mixins-scss/rem';

  .NewsTable {
    .ReactDataTable__wrapper {
      .ReactDataTable {
        tr {
          grid-template-columns:
            minmax(50px, 0.5fr) /* id */
            minmax(150px, 2fr) /* title */
            minmax(150px, 4fr) /* body */
            minmax(100px, 0.7fr) /* published */
            minmax(150px, 1.2fr) /* created */
            minmax(150px, 1fr); /* actions */
        }

        .ReactDataTable__tbody-row {
          height: 70px;
        }

        .ReactDataTable__tbody-cell {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;

          &:nth-child(3) {
            /* body */
            span {
              white-space: normal;
            }

            .body {
              height: 20px;
              margin-right: rem(15px);
              position: relative;
              @include respond-to(sm) {
                height: 18px;
              }
              * {
                padding: 0 !important;
                margin: 0 !important;
                border: none !important;
                text-align: left !important;
                font-size: rem(15px) !important;
                line-height: 1.35 !important;
                font-weight: 400 !important;
              }
              img {
                position: absolute;
                height: 100%;
                width: auto;
              }
              table {
                position: relative;
                bottom: rem(2px);
              }
              a {
                pointer-events: none !important;
              }
            }
          }

          &:nth-child(4) {
            display: flex; /* published */
            justify-content: center;
            span {
              width: 13px;
              height: 13px;
              border-radius: 50%;
            }
          }
        }
      }
    }

    /* --- Responsive layout --- */
    .ResponsiveTable__thead {
      min-width: 320px !important;

      span {
        text-align: center;
        padding: 5px 0;

        &:first-child {
          flex: 2; /* id */
        }

        &:nth-child(2) {
          flex: 10; /* title */
        }

        &:nth-child(3) {
          flex: 4; /* published */
        }
      }
    }

    .ResponsiveTable__row {
      .ResponsiveTable__row-item {
        display: flex;
        align-items: center;

        &:first-child {
          flex: 2; /* id */
          justify-content: center;
        }

        &:nth-child(2) {
          flex: 10; /* title */
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        &:nth-child(3) {
          flex: 4; /* published */
          justify-content: center;

          span {
            width: 13px;
            height: 13px;
            border-radius: 50%;
          }
        }
      }
    }
  }
`;

const getDynamicStyles = ({ colors }) => {
  return css.global`
    .NewsTable {
      .ReactDataTable__tbody-cell:nth-child(4) span {
        background: ${colors.gray.hex};

        &.published {
          background: ${colors.success.hex};
        }
      }

      .ResponsiveTable__row-item:nth-child(3) span {
        background: ${colors.gray.hex};

        &.published {
          background: ${colors.success.hex};
        }
      }
    }
  `;
};

export { staticStyles, getDynamicStyles };
